import { IncidentModelAttributes } from 'src/models/IncidentModel';
export const Incidents: IncidentModelAttributes[] = [
  {
    id: '1',
    publish_time: '2022-03-16T23:36:00+09:00',
    name0: '火災',
    name1: '火災情報',
    name2: '火災発生',
    short_text: 'DD日HH:MM頃、○○区○○町X丁目で火災が発生している模様です。',
    long_text: 'DD日HH:MM頃、○○区○○町X丁目で火災が発生している模様です。',
    event_id: '1',
  },
  {
    id: '2',
    publish_time: '2022-03-16T23:36:00+09:00',
    name0: '気象・自然',
    name1: '地震情報',
    name2: '震度速報',
    short_text:
      '16日23:36頃、宮城県などで最大震度6強を観測する地震が発生しました。（気象庁発表）\n 今後の情報に注意してください。',
    long_text:
      '16日23:36頃、宮城県などで最大震度6強を観測する地震が発生しました。（気象庁発表）\n' +
      '今後の情報に注意してください\n' +
      '［震度3以上が観測された地域］\n' +
      '震度6強 宮城県北部 宮城県南部 福島県中通り 福島県浜通り\n' +
      '震度6弱 宮城県中部\n' +
      '震度5強 岩手県内陸北部 岩手県内陸南部 山形県村山\n' +
      '震度5弱 福島県会津 岩手県沿岸北部 岩手県沿岸南部 山形県最上 山形県置賜 青森県三八上北 秋田県内陸南部 茨城県北部 茨城県南部 栃木県北部 栃木県南部\n' +
      '震度4 山形県庄内 秋田県沿岸北部 秋田県沿岸南部 群馬県南部 埼玉県北部 埼玉県南部 千葉県北東部 千葉県北西部 東京都多摩東部 神奈川県西部 新潟県下越\n' +
      '震度3 青森県津軽北部 青森県津軽南部 青森県下北 秋田県内陸北部 群馬県北部 埼玉県秩父 千葉県南部 東京都多摩西部 新潟県上越 新潟県佐渡 渡島地方東部 山梨県中・西部 山梨県東部・富士五湖 長野県中部 静岡県伊豆 静岡県東部',
    event_id: '2',
  },
];
